import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, connectAuthEmulator, signInWithEmailAndPassword } from "firebase/auth";

// These values are safe to expose in frontend code (Firebase's own docs say
// so) - they identify the project, they don't grant access on their own.
const firebaseConfig = {
  apiKey: "AIzaSyBC4Dlon6LyhwQM1-nkowJLolYFoslYFrA",
  authDomain: "murugappan190.firebaseapp.com",
  projectId: "murugappan190",
  storageBucket: "murugappan190.firebasestorage.app",
  messagingSenderId: "563569336338",
  appId: "1:563569336338:web:b38ef359d7a56e2dfaf8cb",
  measurementId: "G-FKBB0QLMWS",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();

// Local testing only: `REACT_APP_FIREBASE_EMULATORS=true npm start` points
// Auth (and Firestore, see lib/firestore.js) at the Firebase emulators, and
// exposes an email/password sign-in hook for scripted tests. The env var is
// inlined at build time, so production builds drop this block entirely.
if (process.env.REACT_APP_FIREBASE_EMULATORS === "true") {
  connectAuthEmulator(firebaseAuth, "http://127.0.0.1:9099", { disableWarnings: true });
  window.__qpEmulatorSignIn = (email, password) => signInWithEmailAndPassword(firebaseAuth, email, password);
  window.__qpEmulatorSignOut = () => firebaseAuth.signOut();
}
